import Vue from 'vue';
import App from './App.vue';
import router from './router';

import http from './plugins/http';

import toast from './plugins/ToastMessage'
import { Message } from 'element-ui';

import {mobilecheck} from './utils/ua'
if(mobilecheck()){
  Vue.use(toast)
}else{
  Vue.prototype.$message = Message;
}

Vue.config.productionTip = false;

Vue.use(http);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
